import { react2angular } from 'react2angular';
import CustomizeAlertLink from './components/message/CustomizeAlertLink';
import CustomizableVariablesLink from './components/message/CustomizableVariablesLink';
import { alertClearNotificationSettings } from '../../../../common/ui/alert-clear-notifications/AlertClearNotificationSettings';

angular
    .module('signalview.detector.wizard', [
        'signalview.chartbuilder',
        'sfx.api.v2',
        'sfx.ui',
        'sfx.data',
        'sfx.util',
        'signalboost',
        'signalview.sfGlobalNav',
        'signalview.detector',
        'signalview.detector.notification',
        'signalview.detector.rule',
        'signalview.detector.signal',
        'signalview.snapshot',
        'signalview-utils.functions',
        'signalview-utils.signalflowv2',
        'signalflowv2',
    ])
    .component('customizeAlertLink', react2angular(CustomizeAlertLink))
    .component('customizableVariablesLink', react2angular(CustomizableVariablesLink))
    .component('alertClearNotificationSettings', alertClearNotificationSettings);
